<template>
	<div class="coach" v-if="cards.length > 0" :class="{'serious': serious, ...this.effectClasses}" :key="$store.state.calculatorRerender">
        <div class="coach-overlay" :class="{'hidden': hidden}"></div>

        <div class="coach-card" :class="{'hidden': hidden}" ref="coachCard">
            <div class="coach-card-inner">
                <div class="coach-card-inner-top">
                    <div class="coach-card-inner-top-progress">
                        <img v-if=" ! customCoachIcon && serious" src="@/assets/img/coach-info.png" width="30">

                        <span v-html="__('card_coach_page')"></span> {{ index + 1 }} <span v-html="__('of')"></span> {{ cards.length }}
                    </div>

                    <div class="coach-card-inner-top-close" @click="hide()">
                        <img src="@/assets/img/clear.png" width="20">
                    </div>
                </div>

                <div class="coach-card-inner-text">
                    <h3 class="coach-card-title" v-html="$processText(currentCard.title)"></h3>
                    <div v-html="$processText(currentCard.wysiwyg)"></div>

                    <div v-show="currentCard.type === 'coach_preference'">
                        <div class="coach-card-choices">
                            <div class="my-3">
                                <div :class="coachButtonClass('email')" @click="setContactPreference('email')">E-post</div>
                                <div :class="coachButtonClass('phone')" @click="setContactPreference('phone')">SMS</div>
                                <div :class="coachButtonClass('none')" @click="setContactPreference('none')" v-html="__('card_coach_contact_preference_none', 'Nej tack')"></div>
                            </div>

                            <v-text-field :error-messages="errors.email" :error="errors.email.length" v-if="contact_preference.includes('email')" v-model="email" solo :placeholder="__('card_coach_contact_preference_email')"></v-text-field>
                            <v-text-field :error-messages="errors.phone" :error="errors.phone.length" v-if="contact_preference.includes('phone')" v-model="phone" solo :placeholder="__('card_coach_contact_preference_phone')"></v-text-field>
                        </div>
                    </div>

                    <div v-show="currentCard.type === 'coach_input'">
                        <div v-show="currentCard.type_options && ! currentCard.type_options.coach_choice">
                            <v-text-field ref="to" v-model="to" solo :placeholder="__('card_coach_assign_address')"></v-text-field>
                        </div>

                        <div v-if="currentCard.type_options && currentCard.type_options.coach_choice" class="coach-card-choices">
                            <div 
                                class="coach-card-btn" 
                                v-for="layer in layers"
                                :key="layer.id"
                                :style="{'background-color': layer.icon_font_color, 'border-color': layer.icon_font_color, 'color': '#fff'}"
                                @click="setTransportation(layer)"
                            >
                                <i v-if="layer.icon_font" :class="layer.icon_font"></i>

                                <v-img  
                                    v-if="layer.icon && ! layer.icon_font"
                                    :src="$imgUrl(layer.icon)"
                                    height="20px"
                                />
                                
                                {{ layer.__title }}
                            </div>

                            <div class="coach-card-btn" @click="nextStep()" v-html="__('card_coach_other_transportation')"></div>
                        </div>
                    </div>

                    <div class="coach-card-inner-bottom">
                        <div class="coach-card-inner-bottom-owl">
                            <img src="@/assets/img/ugglan.png" v-if=" ! customCoachIcon">
                        </div>
                        
                        <div class="text-right">
                            <div v-if="index > 0" class="coach-card-btn previous" @click="prevStep()" v-html="__('card_coach_button_back')"></div>

                            <div class="coach-card-btn" @click="currentCard.type === 'coach_preference' ? updateEndUserContact() : nextStep()">
                                <span v-if="currentCard.type_options && currentCard.type_options.btn_text">{{ currentCard.type_options.btn_text }}</span>
                                <span v-if=" ! currentCard.type_options || ! currentCard.type_options.btn_text">
                                    {{ this.index === this.cards.length - 1 ? __('card_coach_button_end') : __('card_coach_button_forward') }}
                                </span>

                                <v-progress-circular v-if="loading" class="ml-2" indeterminate :size="15" :width="2" color="primary"></v-progress-circular>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div class="coach-card-bg"></div>
        </div>

		<div class="coach-avatar" @click="toggle()" :style="calcBottom" v-show="hidden">
            <template v-if="customCoachIcon">
                <img :src="$imgUrl(customCoachIcon)">
            </template>

            <template v-if=" ! customCoachIcon">
                <img v-if=" ! serious" src="@/assets/img/coach-avatar.png">
                <img v-if="serious" src="@/assets/img/coach-avatar-serious.png">
            </template>
        </div>
	</div>
</template>

<script>
import scrollTo from 'scroll-to'
import axios from 'axios'

export default {
    name: 'Coach',

    data() {
    	return {
			index: 0,
            to: '',
            phone: null,
            email: null,
            errors: {phone: [], email: []},
            contact_preference: ['none'],
            loading: false,
            effect: null
    	}
    },

    mounted() {
        if (this.$getCookie('hasFinishedCoach')) {
            return
        }

        // Enter after 2 seconds
        if (this.cards.length) {
            setTimeout(() => this.$store.state.coachOpen = true, 2000)
        }
        
        // GMaps autocomplete
        if (this.$refs && this.$refs.to && this.mapsApi) {
            let autoComplete = new this.mapsApi.maps.places.Autocomplete(this.$refs.to.$el.querySelector('input'), {componentRestrictions: {country: 'se'}})

            autoComplete.addListener('place_changed', () => {
                this.$store.state.mapPreserveViewport = true
                this.$store.state.directions[this.currentCard.type_options.input_home_address ? 'from' : 'to'] = autoComplete.getPlace().formatted_address

                if ( ! this.currentCard.type_options.input_home_address) {
                    this.$setCookie('toDestination', this.$store.state.directions.to)
                    this.$setCookie('coachDestination', autoComplete.getPlace().formatted_address)
                } else {
                    this.$setCookie('fromDestination', this.$store.state.directions.from)
                }
            })
        }
        
        // Hide on scroll
        window.addEventListener('scroll', this.hasScrolled)

        // Scroll down a third on mobile
        if (this.onMobile && ! this.$store.state.prestepOpen) {
            scrollTo(0, window.innerHeight / 3, {duration: 0})
        }

        // If there's effects on the first card (not recommended)
        this.$nextTick(() => {
            this.effects()
        })  
    },

    methods: {
        setTransportation(layer) {
            layer.active = true
            layer.point_categories = layer.point_categories.map(c => ({...c, active: layer.active}))
            

            if (layer.title.includes('Promenad')) { this.$store.state.directions.travelMode = 'WALKING' }
            if (layer.title.includes('Cykel')) { this.$store.state.directions.travelMode = 'BICYCLING' }
            if (layer.title.includes('Kollektiv')) { this.$store.state.directions.travelMode = 'TRANSIT' }

            this.nextStep()
        },

        hasScrolled() {
            if (window.scrollY > 1000 && this.index === 0) {
                this.$store.state.coachOpen = false

                window.removeEventListener('scroll', this.hasScrolled)
            }
        },

        prevStep() {
            this.to = ''

            setTimeout(() => this.effects(), 700)
            
            this.index--
        },

        nextStep() {
            this.to = ''

            setTimeout(() => this.effects(), 700)

            if (this.index < this.cards.length - 1) {
                this.index++
            } else {
                // Finished!
                this.$store.state.coachOpen = false
                this.$setCookie('hasFinishedCoach', 1)

                this.$metric({'event': 'coach_interaction', 'InteractionLocation': 'modal', 'InteractionType': 'completed'})
            }
        },

        hide() {
            this.effects(true)
            this.$store.state.coachOpen = false
        },

        toggle() {
            this.$store.state.coachOpen = ! this.$store.state.coachOpen
        },

        coachButtonClass(contactPreference) {
            if (this.contact_preference.includes(contactPreference)) {
                return 'coach-card-btn active'
            }

            return 'coach-card-btn'
        },

        setContactPreference(contactPreference) {
            if (this.contact_preference.includes(contactPreference)) {
                this.contact_preference = this.contact_preference.filter(v => v !== contactPreference)
            } else {
                if (contactPreference === 'none') {
                    this.contact_preference = [contactPreference]
                } else {
                    this.contact_preference = this.contact_preference.filter(v => v !== 'none')
                    this.contact_preference.push(contactPreference)
                }
            }
        },

        updateEndUserContact() {
            if (this.loading) {
                return
            }

            this.loading = true

            axios
                .post(this.$apiUrl + '/api/end-user/' + this.$store.state.endUser.slug + '/update-contact', this.$data)
                .then(res => {
                    this.nextStep()
                    this.loading = false
                    this.errors.phone = []
                    this.errors.email = []
                }).catch(error => {
                    for (let prop in error.response.data) {
                        error.response.data[prop] = error.response.data[prop].map(e => this.__(e))
                    }

                    this.errors = {...this.errors, ...error.response.data}
                    this.loading = false
                })
        },

        effects(close = false) {
            let variableToDist = true
            let newEffect = close ? null : (this.currentCard && this.currentCard.type_options ? this.currentCard.type_options.effects : null)

            this.$store.state.coachEffect = newEffect

            // HIGHLIGHT CARDS, scroll up
            if (newEffect === 'highlight_walking_circle') {
                this.$nextTick(() => {
                    scrollTo(0, 0, {duration: 300})
                })
            }

            // HIGHLIGHT WALKING CIRCLE
            if (newEffect === 'highlight_walking_circle') {
                this.$store.state.walkingCircles.forEach(ml => {
                    ml.setOptions({fillOpacity: .5})
                })

                // scroll to card
                this.$nextTick(() => {
                    //scrollTo(0, 150, {duration: 300})
                })
            }

            // This removes the effect, if it's applied
            if (newEffect !== this.effect && this.effect === 'highlight_walking_circle') {
                console.log('ska kallas, ska ta bort')

                this.$store.state.walkingCircles.forEach(ml => {
                    ml.setOptions({fillOpacity: .15})
                })
            }

            // HIGHLIGHT BIKE LAYER
            if (newEffect === 'highlight_bike_layer') {
                let layer = this.$store.state.layers.find(l => l.title.includes('Cykel') || l.title.includes('Bike'))

                setTimeout(() => {
                    this.$store.state.filterOpen = true
                }, 200)

                setTimeout(() => { 
                    layer.active = false 
                    layer.point_categories = layer.point_categories.map(c => ({...c, active: layer.active}))

                    this.$nextTick(() => this.$store.state.filterHeight = this.$refs.middle.clientHeight)
                    this.$nextTick(() => {
                        if (this.$store.state.markerClusterer) {
                            this.$store.state.markerClusterer.clearMarkers()
                            this.$store.state.markerClusterer.addMarkers(this.$store.state.markers)
                        }
                    })
                }, 600)
                setTimeout(() => { 
                    layer.active = true
                    layer.point_categories = layer.point_categories.map(c => ({...c, active: layer.active}))

                    this.$nextTick(() => this.$store.state.filterHeight = this.$refs.middle.clientHeight)
                    this.$nextTick(() => {
                        if (this.$store.state.markerClusterer) {
                            this.$store.state.markerClusterer.clearMarkers()
                            this.$store.state.markerClusterer.addMarkers(this.$store.state.markers)
                        }
                    })
                }, 3000)

                // setTimeout(() => {
                //     this.$store.state.filterOpen = false
                // }, 4000)
            }

            this.effect = newEffect
        }
    },

    computed: {
        customCoachIcon() {
            return this.$store.state.client?.coach_icon
        },

        hidden() {
            this.$metric({'event': 'coach_interaction', 'InteractionLocation': 'modal', 'InteractionType': this.$store.state.coachOpen ? 'opened' : 'closed'})

            return ! this.$store.state.coachOpen
        },

    	cards() {
            return this.$store.getters.cards
                .filter(c => {
                    // Skip transport preference and to, if already given from public intro
                    if (c.type.includes('coach_input') && c.type_options?.coach_choice && this.$store.state.transportPreference) {
                        return false
                    }

                    if (c.type.includes('coach_input') && ! c.type_options?.coach_choice && this.$store.state.hasChangedTo) {
                        return false
                    }

                    // Check for language and translation
                    if (c.lang && c.lang !== this.$store.state.endUser.language) {
                        return false
                    }

                    return c.type.includes('coach') && ! c.hidden
                })
        },

        currentCard() {
            return this.cards[this.index]
        },

        mapsApi() {
            return this.$store.state.mapsApi
        },

        onMobile() {
            return (/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent))
        },

        endUser() {
            return this.$store.state.endUser
        },

        client() {
            return this.$store.state.client
        },

        layers() {
            return this.$store.getters.translatedLayers
                .filter(l => l.show_in_menu && ! l.hidden)
                .filter(l => l.title !== 'Mer')
        },

        calcBottom() {
            if (this.$store.state.filterOpen && this.$store.state.filterHeight > 30) {
                return {'bottom': this.$store.state.filterHeight + 'px'}
            }

            return null
        },

        serious() {
           return this.currentCard.type_options?.serious
        },

        effectClasses() {
            if (this.currentCard.type_options?.effects) {
                let object = {}
                object['effect ' + this.currentCard.type_options?.effects] = true
                return object
            }

            return null
        },
    }
}
</script>